import { get, post } from './base';

export interface ExportStatus {
  id: number;
  contentType: number;
  objectId: string;
  fieldName: string | null;
  success: boolean;
  errorMessage: string | null;
  createdAt: string;
}

export interface CreateExportStatusPayload {
  objectId: string;
  modelName: string;
  fieldName?: string;
  success?: boolean;
  errorMessage?: string;
}

export const getExportStatus = (objectId: string, contentTypeId?: number) => {
  const params = new URLSearchParams();
  params.append('objectId', objectId);
  if (contentTypeId) {
    params.append('contentType', contentTypeId.toString());
  }
  return get('exportStatus', undefined, Object.fromEntries(params)) as Promise<ExportStatus[]>;
};

export const createExportStatus = (payload: CreateExportStatusPayload) => {
  return post('exportStatus', payload) as Promise<ExportStatus>;
};
